import React from 'react';
import { cn } from 'utils';
import { VideoCameraInaccessible } from './VideoCameraInaccessible';

export function VideoThumbnail(props: {
  fitHeight?: boolean;
  label?: string;
  url?: string;
  fallback?: React.ReactNode | React.FunctionComponent<{ text?: string }>;
}): React.ReactElement {
  const { fallback = VideoCameraInaccessible, fitHeight, label, url } = props;
  const [failed, setFailed] = React.useState(false);

  React.useEffect(() => {
    setFailed(false);
  }, [url]);

  // If the image fails to load and a fallback is provided, render the fallback
  if (failed && fallback) {
    if (React.isValidElement(fallback)) {
      return fallback;
    }
    if (typeof fallback === 'function') {
      const FallbackComponent = fallback;
      return <FallbackComponent />;
    }
  }

  return (
    <div
      className={cn('odin-aspect-video', 'odin-flex', {
        'odin-h-full': fitHeight,
      })}
    >
      <img
        src={url}
        alt={label}
        className="odin-h-full odin-object-cover odin-w-full"
        onError={() => setFailed(true)}
      />
    </div>
  );
}
